// extracted by mini-css-extract-plugin
export default {"bg":"header_bg__7b3Qv","header":"header_header__PXGD2","imgContainer":"header_imgContainer__P9gMZ","buttons":"header_buttons__ZXkH9"};